import React,{useEffect} from "react";
import "./DemandPromissoryNote.css";
import { Grid, Stack } from "@mui/material";
import Proptypes from "prop-types";
import { ImageBaseUrl } from "../../Environment";
import { getSecureItem } from "../../utilsFunctions";
import { SignatureLabels } from "../../Constants/SignatureLabels";

export const DemandPromissoryNote = ({ branchAddress = null, data, printRef, language, signatureType }) => {
  const countryCode = getSecureItem("country")?.code;
  const countryCurrency = getSecureItem("country")?.symbol

  const companyData = data?.company;
  const userData = data?.user;
  const customerSignaturePic = data?.proofs?.find(p => p.proofType === "uploadSignature")?.proofImagePath;
  const AdminSignature = companyData?.users?.find(
    u =>
      u.userType === "Admin" &&
      u.branchId === data?.branchId &&
      u.userSignaturePath
  )?.userSignaturePath ||
    companyData?.users?.find(
      u => u.userType === "superAdmin" && u.userSignaturePath
    )?.userSignaturePath ||
    null;
  const loanData = data?.loans[0];
  const addressData = data?.addresses[0];

  const { firstName, lastName, fatherName } = data;

      useEffect(() => {
      const customerName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
      document.title = `Demand Promissory Note - ${customerName || "Customer"}`;
  
      return () => {
        document.title = "LendStack - Forging Digital OneOffice for Micro Business";
      };
    }, [firstName, lastName]);

  const getAddress = (address) =>
    [
      address?.AddressStreet,
      address?.AddressLandmark,
      address?.AddressCity,
      address?.AddressState,
      address?.AddressPincode,
    ]
      .filter(Boolean)
      .join(", ");

  return (
    <div ref={printRef} className="demand-promissory-note">
      <Grid container>
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          paddingX={2}
          style={{ border: "1px solid black" }}
        >
          <div className="header-left">
            {companyData?.profilePic ? (
              <img
                src={
                  getSecureItem("loggedinUserCompany") == "1365"
                    ? "https://i.imghippo.com/files/CCD2780qQ.jpeg"
                    : `${ImageBaseUrl}${companyData?.profilePic}`
                }
                alt="Logo"
                className="logo"
              />
            ) : (
              <div
                style={{
                  height: "120px",
                }}
              ></div>
            )}
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          md={8}
          paddingX={2}
          style={{ border: "1px solid black", borderRightWidth: "0px" }}
        >
          <div className="header-right">
            <h1>{companyData?.companyName}</h1>
            <p>
              <strong>Address: </strong> {branchAddress ? branchAddress : getAddress(companyData)}
              <br />
              <strong>GSTIN: </strong> {companyData?.GstIn || ""} |{" "}
              <strong>CIN: </strong> {companyData?.CIN || ""} |{" "}
              <strong>Website: </strong> {companyData?.companyWebsite || ""}
              <br />
              <strong>Mobile No: </strong> {companyData?.phone}{" "}
              <strong>| Email ID: </strong> {companyData?.companyMail}
            </p>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          paddingX={2}
          style={{ border: "1px solid black", borderLeftWidth: "0px" }}
        />
      </Grid>
      <h2 className="title">Demand Promissory Note</h2>

      <Stack spacing={5} marginTop={6}>
        {(countryCode == '91' && language == 'ta') && <div>
          <strong>தொகை: {countryCurrency}{loanData?.loanAmount}</strong>
          <br /> நான் திரு/திருமதி{" "}
          <strong>
            {firstName} {lastName} த/பெ {fatherName}
          </strong>{" "}
          முகவரி{" "}
          <strong>
            {addressData?.AddressStreet} {addressData?.AddressLandmark}
          </strong>
          , மாவட்டம் <strong>{addressData?.AddressCity}</strong>, மாநிலம்{" "}
          <strong>
            {addressData?.AddressState}, {addressData?.AddressPincode}
          </strong>{" "}
          வசிப்பவன்/வசிப்பவள் ஆகிறேன். {companyData?.companyName} அவர்களிடமிருந்து
          பெற்ற {countryCurrency}{loanData?.loanAmount} கடன் தொகையை, கடன் விண்ணப்பத்தில்
          நான் முன்பே சரிபார்த்து கையொப்பமிட்டுள்ள திருப்பிச் செலுத்தும் அட்டவணைபடி
          EMI தவணைகளாக செலுத்துவேன் என்று உறுதியளிக்கிறேன்.
        </div>}
        {(countryCode == '91' && language == 'hi') && <div>
          <strong>राशि: {countryCurrency}{loanData?.loanAmount}</strong>
          <br /> मैं श्री/श्रीमती{" "}
          <strong>
            {firstName} {lastName} c/o {fatherName}
          </strong>{" "}
          निवासी{" "}
          <strong>
            {addressData?.AddressStreet} {addressData?.AddressLandmark}
          </strong>
          , जिला <strong>{addressData?.AddressCity}</strong>, राज्य{" "}
          <strong>
            {addressData?.AddressState}, {addressData?.AddressPincode}
          </strong>{" "}
          का मूल निवासी हूँ। {companyData?.companyName} द्वारा मांगे जाने पर
          मेरे द्वारा प्राप्त की गई ऋण राशि {countryCurrency}{loanData?.loanAmount} का मैं अपने
          ऋण चुकौती की अनुसूची के अनुसार EMI किस्तों का भुगतान करने का वादा
          करता/करती हूँ, जिसे पहले ऋण आवेदन पत्र में मेरे द्वारा जांचा और
          हस्ताक्षरित किया गया था।
        </div>}
        {(countryCode == '91' && language == 'te') && <div>
          <strong>మొత్తం: {countryCurrency}{loanData?.loanAmount}</strong>
          <br /> నేను శ్రీ/శ్రీమతి{" "}
          <strong>
            {firstName} {lastName} తండ్రి పేరు {fatherName}
          </strong>{" "}
          నివాసం{" "}
          <strong>
            {addressData?.AddressStreet} {addressData?.AddressLandmark}
          </strong>
          , జిల్లా <strong>{addressData?.AddressCity}</strong>, రాష్ట్రం{" "}
          <strong>
            {addressData?.AddressState}, {addressData?.AddressPincode}
          </strong>{" "}
          కు చెందినవాడిని/చెందినవాణ్ని. {companyData?.companyName} నుండి
          పొందిన {countryCurrency}{loanData?.loanAmount} రుణాన్ని, నేను ముందుగా పరిశీలించి
          సంతకం చేసిన రుణ దరఖాస్తు పత్రంలో పేర్కొన్న చెల్లింపు షెడ్యూల్ ప్రకారం
          EMI వాయిదాలుగా చెల్లించడానికి హామీ ఇస్తున్నాను.
        </div>}
        {(countryCode == '91' && language == 'ml') && <div>
          <strong>തുക: {countryCurrency}{loanData?.loanAmount}</strong>
          <br /> ഞാൻ ശ്രീ/ശ്രീമതി{" "}
          <strong>
            {firstName} {lastName} പിതാവ് {fatherName}
          </strong>{" "}
          വിലാസം{" "}
          <strong>
            {addressData?.AddressStreet} {addressData?.AddressLandmark}
          </strong>
          , ജില്ല <strong>{addressData?.AddressCity}</strong>, സംസ്ഥാനം{" "}
          <strong>
            {addressData?.AddressState}, {addressData?.AddressPincode}
          </strong>{" "}
          സ്വദേശിയാണ്. {companyData?.companyName} ൽ നിന്ന് ലഭിച്ച
          {countryCurrency}{loanData?.loanAmount} രൂപയുടെ വായ്പ തുക, ഞാൻ മുമ്പ് പരിശോധിച്ച്
          ഒപ്പുവെച്ച വായ്പ അപേക്ഷയിലെ തിരിച്ചടവ് പട്ടിക പ്രകാരം EMI തവണകളായി
          അടയ്ക്കുമെന്ന് ഇതോടെ വാഗ്ദാനം ചെയ്യുന്നു.
        </div>}
        {(countryCode == '91' && language == 'kn') && <div>
          <strong>ಮೊತ್ತ: {countryCurrency}{loanData?.loanAmount}</strong>
          <br /> ನಾನು ಶ್ರೀ/ಶ್ರೀಮತಿ{" "}
          <strong>
            {firstName} {lastName} ತಂದೆ {fatherName}
          </strong>{" "}
          ವಿಳಾಸ{" "}
          <strong>
            {addressData?.AddressStreet} {addressData?.AddressLandmark}
          </strong>
          , ಜಿಲ್ಲೆ <strong>{addressData?.AddressCity}</strong>, ರಾಜ್ಯ{" "}
          <strong>
            {addressData?.AddressState}, {addressData?.AddressPincode}
          </strong>{" "}
          ನಿವಾಸಿಯಾಗಿದ್ದೇನೆ. {companyData?.companyName} ಇಂದ ಪಡೆದ
          {countryCurrency}{loanData?.loanAmount} ಸಾಲವನ್ನು, ನಾನು ಮೊದಲು ಪರಿಶೀಲಿಸಿ
          ಸಹಿ ಮಾಡಿದ ಸಾಲ ಅರ್ಜಿಯಲ್ಲಿರುವ ಮರುಪಾವತಿ ವೇಳಾಪಟ್ಟಿಯ ಪ್ರಕಾರ EMI ಕಂತುಗಳಲ್ಲಿ
          ಪಾವತಿಸುವುದಾಗಿ ಈ ಮೂಲಕ ಭರವಸೆ ನೀಡುತ್ತೇನೆ.
        </div>}
        {(countryCode == '91' && language == 'mr') && <div>
          <strong>रक्कम: {countryCurrency}{loanData?.loanAmount}</strong>
          <br /> मी श्री/श्रीमती{" "}
          <strong>
            {firstName} {lastName} वडील {fatherName}
          </strong>{" "}
          राहणार{" "}
          <strong>
            {addressData?.AddressStreet} {addressData?.AddressLandmark}
          </strong>
          , जिल्हा <strong>{addressData?.AddressCity}</strong>, राज्य{" "}
          <strong>
            {addressData?.AddressState}, {addressData?.AddressPincode}
          </strong>{" "}
          येथील रहिवासी आहे. {companyData?.companyName} कडून घेतलेली
          {countryCurrency}{loanData?.loanAmount} कर्जरक्कम मी यापूर्वी तपासून स्वाक्षरी केलेल्या
          कर्ज अर्जातील परतफेड वेळापत्रकानुसार EMI हप्त्यांमध्ये परत करण्याचे
          वचन देतो/देते.
        </div>}
        {(countryCode == '91' && language == 'gu') && <div>
          <strong>રકમ: {countryCurrency}{loanData?.loanAmount}</strong>
          <br /> હું શ્રી/શ્રીમતી{" "}
          <strong>
            {firstName} {lastName} પિતા {fatherName}
          </strong>{" "}
          રહેવાસી{" "}
          <strong>
            {addressData?.AddressStreet} {addressData?.AddressLandmark}
          </strong>
          , જિલ્લા <strong>{addressData?.AddressCity}</strong>, રાજ્ય{" "}
          <strong>
            {addressData?.AddressState}, {addressData?.AddressPincode}
          </strong>{" "}
          નો રહેવાસી છું. {companyData?.companyName} પાસેથી લીધેલી
          {countryCurrency}{loanData?.loanAmount} ની લોન રકમ હું અગાઉ તપાસી અને સહી કરેલ
          લોન અરજીમાં દર્શાવેલ પરતફેર સમયપત્રક મુજબ EMI હપ્તાઓમાં ચૂકવવાનો
          વચન આપું છું.
        </div>}
        <div>
          <strong>Amount: {countryCurrency}{loanData?.loanAmount}</strong>
          <br /> This is to certify that I,{" "}
          <strong>
            {firstName} {lastName} c/o {fatherName}
          </strong>
          , resident at{" "}
          <strong>
            {addressData?.AddressStreet} {addressData?.AddressLandmark}
          </strong>
          , District - <strong>{addressData?.AddressCity}</strong>, State -{" "}
          <strong>
            {addressData?.AddressState}, {addressData?.AddressPincode}
          </strong>
          , have taken a loan of {countryCurrency}{loanData?.loanAmount} from{" "}
          {companyData?.companyName}. I hereby promise to pay the EMI
          installments as per the schedule of my loan repayment that was
          previously checked and signed by me in the Loan Application Form.
        </div>
        <h3>Date: </h3>
      </Stack>

      <div
        style={{ display: "flex", justifyContent: "flex-end", marginBlock: 80 }}
      >
        <span
          style={{
            width: 100,
            height: 120,
            border: "1px solid black",
            textAlign: "center",
          }}
        >
          STAMP
        </span>
      </div>

      <div className="footer section">
        <table
          className="footer-table"
          style={{ width: "100%", borderCollapse: "collapse" }}
        >
          <tbody>
            <tr>
              <td style={{ border: "1px solid black", textAlign: "center" }}>
                {countryCode == '91' ? 
                  <strong>
                    {SignatureLabels.memberSignature.en}
                    <br />
                    {SignatureLabels.memberSignature[language]}
                  </strong> : 
                  <strong> {SignatureLabels.memberSignature.en}
                  </strong>}
                <br />
                {signatureType && customerSignaturePic ? (
                  <img src={`${ImageBaseUrl}${customerSignaturePic}`} alt="Member Signature" style={{ maxWidth: "100%", maxHeight: "60px", objectFit: "contain", marginTop: 10 }} />
                ) : (
                  <span style={{ marginTop: 30 }} className="input-line"></span>
                )}
              </td>
              <td style={{ border: "1px solid black", textAlign: "center" }}>
                {countryCode == '91' ?
                  <strong>
                    {SignatureLabels.guarantorSignature.en}
                    <br />
                    {SignatureLabels.guarantorSignature[language]}
                  </strong> : 
                  <strong> {SignatureLabels.guarantorSignature.en}
                  </strong>}
                <br />
                <span style={{ marginTop: 30 }} className="input-line"></span>
              </td>
              <td style={{ border: "1px solid black", textAlign: "center" }}>
                {countryCode == '91' ?
                  <strong>
                    {SignatureLabels.branchSealSignature.en}
                    <br />
                    {SignatureLabels.branchSealSignature[language]}
                  </strong> : 
                  <strong> {SignatureLabels.branchSealSignature.en}
                  </strong>}
                <br />
                {signatureType && AdminSignature ? (
                  <img src={`${ImageBaseUrl}${AdminSignature}`} alt="Authorized Signature" style={{ maxWidth: "100%", maxHeight: "60px", objectFit: "contain", marginTop: 10 }} />
                ) : (
                  <span style={{ marginTop: 30 }} className="input-line"></span>
                )}
              </td>
              <td style={{ border: "1px solid black", textAlign: "center" }}>
                {countryCode == '91' ?
                  <strong>
                    {SignatureLabels.companySealSignature.en}
                    <br />
                    {SignatureLabels.companySealSignature[language]}
                  </strong> :
                  <strong> {SignatureLabels.companySealSignature.en}
                  </strong>}
                <br />
                {signatureType && companyData?.signature ? (
                  <img src={`${ImageBaseUrl}${companyData?.signature}`} alt="Authorized Signature" style={{ maxWidth: "100%", maxHeight: "60px", objectFit: "contain", marginTop: 10 }} />
                ) : (
                  <span style={{ marginTop: 30 }} className="input-line"></span>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

DemandPromissoryNote.prototype = {
  data: Proptypes.any,
  printRef: Proptypes.any,
};
